import { useLessons } from '@/api/useLessons';
import { LessonBox } from '@/components/ui/LessonBox/LessonBox';
import { Lesson } from '$/models/Lesson';

const AdminLessonsPage = () => {
  const { data: lessons = [] } = useLessons(true);

  const formatDate = (iso: string | undefined) => {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString('pl-PL');
    } catch {
      return '';
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Lessons</h1>
      <div className="flex flex-wrap gap-4">
        {lessons.map((lesson: Lesson) => (
          <LessonBox
            key={lesson.id}
            id={lesson.id}
            title={lesson.title}
            subject={lesson.subject ?? ''}
            date={formatDate(lesson.created_at)}
            videoUrl={lesson.video_url}
          />
        ))}
      </div>
    </div>
  );
};

export default AdminLessonsPage;
